import React from 'react'
import MyTable from '../../../../UI/table/MyTable'
import { TableCell } from '@mui/material'
import MyTableNotFound from '../../../../UI/table/MyTableNotFound'
import SupplyOrderBillItem from './SupplyOrderBillItem'
import { useSelector } from 'react-redux'

const SupplyOrderBillsTable = ({  }) => {

    const supplyOrder = useSelector(state => state.supplyOrder.supplyOrder)

  return (
    <MyTable
        head={
            <>
                <TableCell align="center">ID</TableCell>
                <TableCell align="center">Статус</TableCell>
                {/* <TableCell align="center">Підрядник</TableCell> */}
                <TableCell align="center">Відповідальний</TableCell>
                <TableCell align="center">Оплата</TableCell>
                <TableCell align="center">Доставка</TableCell>
                {/* <TableCell align="center">Дії</TableCell> */}
            </>
        }
        body={
            // supplyOrderBills && supplyOrderBills.length > 0 ?
            //     supplyOrderBills.map((supplyOrderBill, index) => 
            supplyOrder.bills && supplyOrder.bills.length > 0 ?
                supplyOrder.bills.map((supplyOrderBill, index) => 
                    <SupplyOrderBillItem
                        key={supplyOrderBill.id}
                        supplyOrderBill={supplyOrderBill} 
                    />
                )
            : 
                <MyTableNotFound
                    text='Рахунків не знайдено' 
                    // columns={6}
                />
        }
        name='рахунок'
        hidePagination={true}
        isIconMore={true}
    />
  )
}

export default SupplyOrderBillsTable